import {
    getAxios,
    formDataToRequestParams,
} from './axios'

import {addAuthTokenData} from './member';

export function getMemberNotificationList(params = {}) {
    let axios = getAxios();
    
    return axios.request({
        method: 'get',
        url: '/member/notification/',
        params: {...addAuthTokenData({...params, unread: 0})}
    });
}

export function applyMemberNotificationAction(data = {}) {
    let axios = getAxios();

    return axios.request({
        method: 'post',
        url: '/member/notification/action/',
        data: formDataToRequestParams(addAuthTokenData(data))
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/memberNotificationList.js